import React from 'react';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import PropTypes from 'prop-types';

const DefaultExpandedChildComponent = ({
  collection,
  onSubmit,
  onSubmitBefore,
  onChange,
}) => {
  return (
    <MetaCollectionFormInline
      collection={collection}
      FormProps={{
        onChange,
        onSubmit,
        onSubmitBefore,
      }}
    />
  );
};

DefaultExpandedChildComponent.defaultProps = {
  onSubmit: null,
  onSubmitBefore: null,
  onChange: null,
};

DefaultExpandedChildComponent.propTypes = {
  collection: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onSubmitBefore: PropTypes.func,
};

export default DefaultExpandedChildComponent;
